var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":"动态","left-text":"返回","left-arrow":"","fixed":"","placeholder":""},on:{"click-left":_vm.onClickLeft}}),_c('topic-item',{attrs:{"type":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }